export default "__VITE_ASSET__ccaa0e02__"